import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {IColoumnSelectionInfo, IReportEditData, ITableColumns} from "app/modules/reports/interfaces/reporting-data";
import {
    CdkDragDrop,
    moveItemInArray,
    transferArrayItem,
    CdkDrag,
    CdkDropList,
} from '@angular/cdk/drag-drop';

@Component({
    selector: 'app-report-edit-dialog',
    templateUrl: './report-edit-dialog.component.html',
    styleUrls: ['./report-edit-dialog.component.scss']
})
export class ReportEditDialogComponent implements OnInit {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: IReportEditData,
        private dialogRef: MatDialogRef<ReportEditDialogComponent>
    ) {
    }

    nonSelectedColumns: ITableColumns[];
    selectedColumns: ITableColumns[];
    ngOnInit() {
        let columnData = this.data.columnsProperties.map((obj) => ({ ...obj }));        
        this.nonSelectedColumns = columnData.filter((col) => !col.isSelected);        
        this.selectedColumns = columnData.filter((col) => col.isSelected);
        this.selectedColumns.sort((a, b) => a.fieldOrder - b.fieldOrder);
    }

    applyChanges() {
        let updatedColoumnInfo: IColoumnSelectionInfo = {
            selectedColumns: this.selectedColumns,
            deSelectedColumns: this.nonSelectedColumns,
        };
        this.dialogRef.close(updatedColoumnInfo);
    }

    drop(event: CdkDragDrop<ITableColumns[]>) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        } else {
            transferArrayItem(
                event.previousContainer.data,
                event.container.data,
                event.previousIndex,
                event.currentIndex,
            );
        }
    }
}
